import React, { Component }  from 'react';
import { CardWarning } from '../../../widgets/Cards';



class Messaging extends Component {

    contentList() {
        return <div>1 message from Podiatrist<br></br>
                   
        </div>
    }

    content() {
        return (
            <>
                <h2 style={{marginTop:"-10px"}}>Messages</h2>
                {this.contentList()}
            </>
        )
    }

    render() {
        return (
            <CardWarning
                color = "yellow"
                content = {this.content()}
                icon = "envelope"
            />
        )
        
    }
}

export default Messaging;